import { get, post, put, del, getPage } from '@/utils/request'
import type { Environment } from '@/types'

/** 环境列表 */
export const listEnvironments = (params: {
  project_id: number
  page?: number
  page_size?: number
  keyword?: string
}) => getPage<Environment>('/environments', params)

/** 环境详情 */
export const getEnvironment = (id: number) =>
  get<Environment>(`/environments/${id}`)

/** 创建环境 */
export const createEnvironment = (data: {
  project_id: number
  name: string
  url?: string
  headers?: string
  variables?: string
  description?: string
}) => post<Environment>('/environments', data)

/** 更新环境 */
export const updateEnvironment = (id: number, data: Partial<Environment>, projectId: number) =>
  put<Environment>(`/environments/${id}`, data, { params: { project_id: projectId } })

/** 删除环境 */
export const deleteEnvironment = (id: number, projectId: number) =>
  del(`/environments/${id}`, { params: { project_id: projectId } })
